import React from 'react';
import { cn } from './_cn';

const SectionHeading = ({
  title,
  description,
  action,
  icon: Icon,
  className = '',
}) => {
  const compact = !description;
  return (
    <div
      className={cn(
        'flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between',
        className,
      )}
    >
      <div
        className={cn(
          'flex gap-3',
          compact ? 'items-center' : 'items-start',
        )}
      >
        {Icon ? (
          <Icon
            className="h-6 w-6 shrink-0 text-slate-900 dark:text-slate-100"
            aria-hidden
          />
        ) : null}
        <div className="space-y-1">
          {title ? (
            <h2 className="text-lg font-semibold text-slate-900 dark:text-slate-100">
              {title}
            </h2>
          ) : null}
          {description ? (
            <p className="max-w-2xl text-sm text-slate-500 dark:text-slate-400">
              {description}
            </p>
          ) : null}
        </div>
      </div>
      {action ? <div className="shrink-0">{action}</div> : null}
    </div>
  );
};

export default SectionHeading;
